module.exports = __webpack_public_path__ + "img/click1.e7001dce.png";